var _ = require('lodash');
var omniture = require('./omniture');
var app = require('./application');

module.exports = _.extend({},{
    OMNITURE: omniture,
    APP: app
});



// WEBPACK FOOTER //
// ./app/scripts/constants/index.js